import React from 'react';
import { XIcon } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={onClose} data-id="element-494">
      <div className="bg-slate border border-white/10 rounded-2xl w-full max-w-4xl max-h-[85vh] flex flex-col shadow-2xl relative" onClick={e => e.stopPropagation()} data-id="element-495">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/10 sticky top-0 bg-slate/95 backdrop-blur z-10 rounded-t-2xl" data-id="element-496">
          <h2 className="text-2xl font-bold text-white" data-id="element-497">
            Terms and Conditions of Use
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-white/5 text-gray-400 hover:text-white transition-colors" aria-label="Close modal" data-id="element-498">
            <XIcon className="w-6 h-6" data-id="element-499" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="p-6 md:p-8 overflow-y-auto text-gray-300 space-y-8 text-sm md:text-base leading-relaxed" data-id="element-500">
          <section data-id="element-501">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-502">
              Welcome to FIQIS
            </h3>
            <p data-id="element-503">
              This site is maintained as a service to our clients. By using this
              site, you agree to comply with and be bound by the following terms
              and conditions of use, which are expressly subject to the terms
              and conditions outlined in the Master Service Agreement. Please
              review these terms and conditions carefully. Please refrain from
              using FIQIS (the "Site") if you do not accept all of the terms and
              conditions stated on this page, as well as those specified in the
              Master Service Agreement.
            </p>
          </section>

          <section data-id="element-504">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-505">
              1. Terminology
            </h3>
            <p data-id="element-506">
              The following terminology applies to these Terms and Conditions
              and Privacy Policy, and any or all Agreements: "Client",
              "Customer", "You" and "Your" refers to you, the person accessing
              this website and accepting the Company's terms and conditions. The
              terms "FIQIS", "the Company", "Ourselves", "We", "Our" and "Us",
              refers to our Company, FIQIS Inc., a Delaware Corporation. The
              terms "Party", "Parties", or "Us", refers to both the Client and
              ourselves, or either the Client or ourselves. All terms refer to
              the offer, acceptance, and consideration of payment necessary to
              undertake the process of our assistance to the Client in the most
              appropriate manner, whether by formal meetings of a fixed
              duration, or any other means, for the express purpose of meeting
              the Client's needs in respect of provision of the Company's stated
              services/products, in accordance with and subject to, prevailing
              law of Delaware. Any use of the above terminology or other words
              in the singular, plural, capitalization and/or he/she or they, are
              taken as interchangeable and therefore as referring to same.
            </p>
          </section>

          <section data-id="element-507">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-508">
              2. Agreement
            </h3>
            <p data-id="element-509">
              This Terms and Conditions of Use Agreement (the "Agreement")
              governs your access to and use of the website operated by FIQIS
              (the "Site"), as well as any related services offered by FIQIS
              (collectively, the "Services"). By accessing or using the Site or
              Services, you acknowledge that you have read, understood, and
              agree to be bound by the terms and conditions set forth herein.
              FIQIS reserves the right to modify this Agreement at any time, and
              such modifications shall become effective immediately upon
              posting. It is your responsibility to review the most current
              version of this Agreement, available at fiqis.com. Each use of the
              Site or Services by you shall constitute your acceptance of the
              then-current version of this Agreement.
            </p>
          </section>

          <section data-id="element-510">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-511">
              3. Eligibility
            </h3>
            <p data-id="element-512">
              Access to and use of the Services is strictly limited to
              individuals who are at least eighteen (18) years of age. By
              accessing or using the Site or Services, you represent and warrant
              that you are at least eighteen (18) years old and legally capable
              of entering into binding agreements. Under no circumstances may
              any individual under the age of eighteen (18) access or use the
              Site or Services. FIQIS does not knowingly permit or collect
              information from individuals under the age of eighteen (18), and
              any such use is strictly prohibited.
            </p>
          </section>

          <section data-id="element-513">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-514">
              4. Account Registration and Management
            </h3>
            <p data-id="element-515">
              Certain features of the Services may require users to create an
              account. In such cases, you agree to provide accurate, current,
              and complete information during the registration process and to
              update such information as necessary to maintain its accuracy. You
              are solely responsible for maintaining the confidentiality and
              security of your account credentials and for all activities
              conducted under your account. FIQIS reserves the right to suspend
              or terminate any account that, in its sole discretion, is found to
              be in violation of this Agreement, involved in fraudulent or
              unauthorized activity, or otherwise detrimental to the integrity
              or operation of the Services.
            </p>
          </section>

          <section data-id="element-516">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-517">
              5. Scope of Services; Refund and Cancellation Policy
            </h3>
            <p data-id="element-518">
              FIQIS provides a suite of financial technology services which
              include: (i) the facilitation of peer-to-peer lending
              transactions; (ii) the offering of micro-loans; (iii) the
              generation of trust scores for user accounts based on defined
              metrics; and (iv) the provision of generative AI-based reports
              analyzing user qualifications for loan eligibility. FIQIS
              maintains a strict no-refund policy for all Services provided,
              regardless of usage, satisfaction, or circumstances surrounding
              termination. By utilizing the Services, you acknowledge and affirm
              your understanding and acceptance of this policy and waive any
              right to claim a refund or partial reimbursement. Termination of
              membership is governed solely by the terms set forth in the
              applicable membership agreement executed between you and FIQIS.
            </p>
          </section>

          <section data-id="element-519">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-520">
              6. Cookies
            </h3>
            <p className="mb-4" data-id="element-521">
              We employ the use of first-party and third-party cookies for
              several reasons. By using FIQIS's website you consent to the use
              of cookies in accordance with FIQIS's privacy policy. Some cookies
              are required for technical reasons in order for our website to
              operate, and we refer to these as "essential" or "strictly
              necessary" cookies. Other cookies enable us to track and target
              the interests of our users to enhance the experience on our
              website. Third parties serve cookies through our website for
              advertising, analytics, and other purposes. This is described in
              more detail below.
            </p>
            <div className="space-y-4 pl-4 border-l-2 border-teal/20" data-id="element-522">
              <div data-id="element-523">
                <p className="font-semibold text-teal mb-1" data-id="element-524">
                  A) Retargeting Cookies
                </p>
                <p data-id="element-525">
                  We use retargeting cookies to show ads to users who have
                  previously visited our website as they browse the web or use
                  social media. These cookies are used to collect information
                  about your browsing habits and to make advertising relevant to
                  you and your interests. They remember that you have visited a
                  website and this information is shared with other
                  organizations such as advertisers.
                </p>
              </div>
              <div data-id="element-526">
                <p className="font-semibold text-teal mb-1" data-id="element-527">
                  B) Behavioral Cookies
                </p>
                <p data-id="element-528">
                  Behavioral cookies are used to collect data about your use of
                  our website. This allows us to understand your preferences and
                  behavior on our website, enabling us to provide you with a
                  more personalized experience. This information is used to
                  enhance the functionality and features of our website, and to
                  provide analytics on website usage.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-529">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-530">
              7. Control Over Cookies
            </h3>
            <p data-id="element-531">
              You have the right to decide whether to accept or reject cookies.
              You can exercise your cookie preferences by clicking on the
              appropriate opt-out links provided in the cookie banner that
              appears when you visit our website. Additionally, most browsers
              allow you to control cookies through their settings preferences.
              However, if you limit the ability of websites to set cookies, you
              may worsen your overall user experience, since it will no longer
              be personalized to you.
            </p>
          </section>

          <section data-id="element-532">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-533">
              8. Privacy
            </h3>
            <p data-id="element-534">
              Your visit to our site is also governed by our Privacy Policy.
              Please review our Privacy Policy at fiqis.com.
            </p>
          </section>

          <section data-id="element-535">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-536">
              9. License
            </h3>
            <p className="mb-4" data-id="element-537">
              Unless otherwise stated, FIQIS and/or its licensors own the
              intellectual property rights for all material on the Site. All
              content included on this site is and shall continue to be the
              property of FIQIS or its content suppliers and is protected under
              applicable copyright, patent, trademark, and other proprietary
              rights. Any copying, redistribution, use or publication by you of
              any such content or any part of the Site is prohibited, except as
              expressly permitted in this Agreement. Under no circumstances will
              you acquire any ownership rights or other interest in any content
              by or through your use of this Site. You may view and/or print
              pages from fiqis.com for your own personal use subject to
              restrictions set in these terms and conditions.
            </p>
            <p className="mb-2 font-semibold text-white" data-id="element-538">You must not:</p>
            <div className="space-y-2 pl-4 border-l-2 border-teal/20" data-id="element-539">
              <p data-id="element-540">
                <span className="text-teal font-medium" data-id="element-541">A)</span> Republish
                material from the Site
              </p>
              <p data-id="element-542">
                <span className="text-teal font-medium" data-id="element-543">B)</span> Sell, rent or
                sub-license material from the Site
              </p>
              <p data-id="element-544">
                <span className="text-teal font-medium" data-id="element-545">C)</span> Reproduce,
                duplicate or copy material from the Site
              </p>
              <p data-id="element-546">
                <span className="text-teal font-medium" data-id="element-547">D)</span> Redistribute
                content from FIQIS (unless content is specifically made for
                redistribution).
              </p>
            </div>
          </section>

          <section data-id="element-548">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-549">
              10. Trademarks
            </h3>
            <p data-id="element-550">
              FIQIS and FIQIS logos found on the Site and others are either
              trademarks or registered trademarks of FIQIS Inc. Other product
              and company names mentioned on this Site may be trademarks of
              their respective owners.
            </p>
          </section>

          <section data-id="element-551">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-552">
              11. Site Use
            </h3>
            <p data-id="element-553">
              FIQIS Inc. grants you a limited, revocable, nonexclusive license
              to use this site solely for your own personal use and not for
              republication, distribution, assignment, sublicense, sale,
              preparation of derivative works, or other use. You agree not to
              copy materials on the site, reverse engineer or break into the
              site, or use materials, products or services in violation of any
              law. The use of this website is at the discretion of FIQIS, and
              FIQIS may terminate your use of this website at any time.
            </p>
          </section>

          <section data-id="element-554">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-555">
              12. Content Liability
            </h3>
            <p data-id="element-556">
              We shall have no responsibility or liability for any content
              appearing on your Web site. You agree to indemnify and defend us
              against all claims arising out of or based upon your Website. No
              link(s) may appear on any page on your Web site or within any
              context containing content or materials that may be interpreted as
              libelous, obscene or criminal, or which infringes, otherwise
              violates, or advocates the infringement or other violation of, any
              third party rights.
            </p>
          </section>

          <section data-id="element-557">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-558">
              13. Compliance with Laws
            </h3>
            <p data-id="element-559">
              You agree to comply with all applicable laws regarding your use of
              the website. You further agreed that information provided by you
              is truthful and accurate to the best of your knowledge.
            </p>
          </section>

          <section data-id="element-560">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-561">
              14. Indemnification
            </h3>
            <p data-id="element-562">
              You agree to indemnify, defend and hold FIQIS Inc., its
              affiliates, and its respective officers, directors, employees,
              agents, successors, and assigns from and against any and all
              losses, damages, liabilities, deficiencies, obligations, claims,
              actions, suits, proceedings, demands, judgments, assessments,
              fines, interest, penalties, costs, and expenses (including
              settlement costs and reasonable legal, accounting, experts' and
              other fees, costs and expenses) arising out of or in connection
              with your violation of this Agreement or use of the Site.
            </p>
          </section>

          <section data-id="element-563">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-564">
              15. Disclaimer
            </h3>
            <p className="uppercase text-gray-400 text-xs md:text-sm leading-relaxed" data-id="element-565">
              THE INFORMATION ON THIS SITE IS PROVIDED ON AN "AS IS," "AS
              AVAILABLE" BASIS. YOU AGREE THAT USE OF THIS SITE IS AT YOUR SOLE
              RISK. FIQIS INC. DISCLAIMS ALL WARRANTIES OF ANY KIND, INCLUDING
              BUT NOT LIMITED TO ANY EXPRESS WARRANTIES, STATUTORY WARRANTIES,
              AND ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR PURPOSE, AND NON-INFRINGEMENT. TO THE EXTENT YOUR
              JURISDICTION DOES NOT ALLOW LIMITATIONS ON WARRANTIES, THIS
              LIMITATION MAY NOT APPLY TO YOU. YOUR SOLE AND EXCLUSIVE REMEDY
              RELATING TO YOUR USE OF THE SITE SHALL BE TO DISCONTINUE USING THE
              SITE.
            </p>
          </section>

          <section data-id="element-566">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-567">
              16. Limitation of Liability
            </h3>
            <p className="uppercase text-gray-400 text-xs md:text-sm leading-relaxed mb-4" data-id="element-568">
              UNDER NO CIRCUMSTANCES WILL FIQIS INC. BE LIABLE OR RESPONSIBLE
              FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL (INCLUDING
              DAMAGES FROM LOSS OF BUSINESS, LOST PROFITS, LITIGATION, OR THE
              LIKE), SPECIAL, EXEMPLARY, PUNITIVE, OR OTHER DAMAGES, UNDER ANY
              LEGAL THEORY, ARISING OUT OF OR IN ANY WAY RELATING TO THE SITE,
              YOUR SITE USE, OR THE CONTENT, EVEN IF ADVISED OF THE POSSIBILITY
              OF SUCH DAMAGES. YOUR SOLE REMEDY FOR DISSATISFACTION WITH THE
              SITE AND/OR CONTENT IS TO CEASE ALL OF YOUR SITE USE.
            </p>
            <p data-id="element-569">
              You may have additional rights under certain laws (including
              consumer laws) which do not allow the exclusion of implied
              warranties, or the exclusion or limitation of certain damages. If
              these laws apply to you, the exclusions or limitations in this
              Agreement that directly conflict with such laws may not apply to
              you.
            </p>
          </section>

          <section data-id="element-570">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-571">
              17. Use of Information
            </h3>
            <p data-id="element-572">
              FIQIS Inc. reserves the right, and you authorize us, to use and
              assign all information regarding site uses by you and all
              information provided by you in any manner consistent with our
              Privacy Policy.
            </p>
          </section>

          <section data-id="element-573">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-574">
              18. Copyrights and Copyright Agent
            </h3>
            <p className="mb-4" data-id="element-575">
              If you believe your work has been copied in a way that constitutes
              copyright infringement, or your intellectual property rights have
              otherwise been violated, please provide a notice containing all of
              the following information to our Copyright Agent:
            </p>
            <div className="space-y-2 pl-4 border-l-2 border-teal/20 mb-4" data-id="element-576">
              <p data-id="element-577">
                <span className="text-teal font-medium" data-id="element-578">A)</span> An electronic
                or physical signature of the person authorized to act on behalf
                of the owner of the copyright or other intellectual property
                interest;
              </p>
              <p data-id="element-579">
                <span className="text-teal font-medium" data-id="element-580">B)</span> A description
                of the copyrighted work that you claim has been infringed;
              </p>
              <p data-id="element-581">
                <span className="text-teal font-medium" data-id="element-582">C)</span> A description
                of where the material that you claim is infringing is located on
                the Site;
              </p>
              <p data-id="element-583">
                <span className="text-teal font-medium" data-id="element-584">D)</span> Your address,
                telephone number, and e-mail address;
              </p>
              <p data-id="element-585">
                <span className="text-teal font-medium" data-id="element-586">E)</span> A statement by
                you that you have a good faith belief that the disputed use is
                not authorized by the copyright owner, its agent, or the law;
                and
              </p>
              <p data-id="element-587">
                <span className="text-teal font-medium" data-id="element-588">F)</span> A statement by
                you, made under penalty of perjury, that the above information
                in your notice is accurate and that you are the copyright owner
                or authorized to act on the copyright owner's behalf.
              </p>
            </div>
            <div className="bg-navy/50 p-4 rounded-lg border border-white/5 space-y-2" data-id="element-589">
              <p className="font-semibold text-white mb-2" data-id="element-590">
                Our Copyright Agent can be reached as follows:
              </p>
              <p data-id="element-591">
                <span className="font-semibold text-teal" data-id="element-592">Phone:</span>{' '}
                480-462-9577
              </p>
              <p data-id="element-593">
                <span className="font-semibold text-teal" data-id="element-594">Email:</span>{' '}
                arthur@fiqis.com
              </p>
            </div>
          </section>

          <section data-id="element-595">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-596">
              19. Applicable Law
            </h3>
            <p data-id="element-597">
              You agree that the laws of the state of Delaware, without regard
              to conflicts of laws provisions will govern these Terms and
              Condition of Use and any dispute that may arise between you and
              FIQIS Inc. or its affiliates.
            </p>
          </section>

          <section data-id="element-598">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-599">
              20. Severability
            </h3>
            <p data-id="element-600">
              If any provision of this Agreement shall be adjudged by any court
              of competent jurisdiction to be unenforceable or invalid, that
              provision shall be limited or eliminated to the minimum extent
              necessary so that this Agreement will otherwise remain in full
              force and effect.
            </p>
          </section>

          <section data-id="element-601">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-602">
              21. Waiver
            </h3>
            <p data-id="element-603">
              The failure of FIQIS to exercise or enforce any right or provision
              of this Agreement shall not operate as a waiver of such right or
              provision. Any waiver of this Agreement by FIQIS must be in
              writing and signed by an authorized representative of FIQIS.
            </p>
          </section>

          <section data-id="element-604">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-605">
              22. Termination
            </h3>
            <p data-id="element-606">
              FIQIS may terminate this Agreement at any time, with or without
              notice, for any reason.
            </p>
          </section>

          <section data-id="element-607">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-608">
              23. Relationship of the Parties
            </h3>
            <p data-id="element-609">
              Nothing contained in this Agreement or your use of the Site shall
              be construed to constitute either party as a partner, joint
              venturer, employee or agent of the other party, nor shall either
              party hold itself out as such. Neither party has any right or
              authority to incur, assume or create, in writing or otherwise, any
              warranty, liability or other obligation of any kind, express or
              implied, in the name of or on behalf of the other party, it being
              intended by both parties that each shall remain independent
              contractors responsible for its own actions.
            </p>
          </section>

          <section data-id="element-610">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-611">
              24. Entire Agreement
            </h3>
            <p data-id="element-612">
              This Terms of Use constitutes the entire agreement between you and
              FIQIS and governs the terms and conditions of your use of the
              Site, and supersedes all prior or contemporaneous communications
              and proposals, whether electronic, oral or written, between you
              and FIQIS with respect to this Site. Notwithstanding the
              foregoing, you may also be subject to additional terms and
              conditions, posted policies (including but not limited to the
              Privacy Policy), guidelines, or rules that may apply when you use
              the website. FIQIS may revise this Terms of Use at any time by
              updating this Agreement and posting it on the Site. Accordingly,
              you should visit the Site and review the Terms of Use periodically
              to determine if any changes have been made. Your continued use of
              this website after any changes have been made to the Terms of Use
              signifies and confirms your acceptance of any such changes or
              amendments to the Terms of Use.
            </p>
          </section>

          <section data-id="element-613">
            <h3 className="text-xl font-semibold text-white mb-4" data-id="element-614">
              25. Contact Information
            </h3>
            <p data-id="element-615">FIQIS Inc.</p>
          </section>

          <section className="border-t border-white/10 pt-8 space-y-6" data-id="element-616">
            <div data-id="element-617">
              <h3 className="text-xl font-semibold text-white mb-4" data-id="element-618">Consent</h3>
              <p data-id="element-619">
                By using our Service, you hereby consent to our Terms and
                Conditions of Use. If you are using the Service on behalf of an
                organization, you are agreeing to these Terms for that
                organization and promising that you have the authority to bind
                that organization to these terms. In that case, "you" and "your"
                will refer to that organization.
              </p>
            </div>

            <div data-id="element-620">
              <h3 className="text-xl font-semibold text-white mb-4" data-id="element-621">
                Electronic Agreement
              </h3>
              <p data-id="element-622">
                By using our Service, you agree to be bound by this electronic
                Agreement, which sets forth the legally binding terms of your
                use. Your continued use of the Service, including registering,
                clicking "I Agree" or "Accept" (or a similar button or
                checkbox), or otherwise accessing the Service, constitutes your
                acceptance of these Terms, as they may be updated or amended at
                the sole discretion of FIQIS Inc.. You acknowledge that you can
                electronically receive, download, and print this Agreement.
              </p>
            </div>

            <div data-id="element-623">
              <h3 className="text-xl font-semibold text-white mb-4" data-id="element-624">
                Acknowledgement
              </h3>
              <p data-id="element-625">
                By using the Service, you acknowledge that you have read these
                Terms and Conditions of Use and agree to be bound by them.
              </p>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-white/10 bg-slate/95 backdrop-blur rounded-b-2xl flex justify-end" data-id="element-626">
          <button onClick={onClose} className="bg-teal hover:bg-teal-400 text-navy font-semibold px-6 py-2.5 rounded-md transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,212,170,0.4)]" data-id="element-627">
            Close
          </button>
        </div>
      </div>
    </div>;
}